import { Panel, PanelBody, PanelHeader, Loader } from "@/shared";

interface PanelLoaderProps {
  panelTitle: string;
}
export const PanelLoader = ({ panelTitle }: PanelLoaderProps) => {
  return (
    <Panel>
      <PanelHeader noButton={true}>{panelTitle}</PanelHeader>
      <PanelBody>
        <Loader className="my-[100px]" />
      </PanelBody>
    </Panel>
  );
};
